import { deleteCookie } from '@ui/lib/cookies'

import {
  hasGpcSignal,
  readConsentRecord,
  readEffectiveConsent,
  writeConsentRecord,
  type ConsentState,
} from './cookie'
import type { ConsentDecisionAction } from './events'
import type { ConsentRequest } from './request'

// Google leaves these behind once denied.
const ADVERTISING_COOKIE = /^_gcl_/

// The route is the writer: an HTTP cookie outlives Safari's script-cookie deletion.
async function postConsent(body: ConsentRequest) {
  try {
    const res = await fetch('/api/consent', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body),
    })
    return res.ok
  } catch {
    return false
  }
}

// Reloads only when the choice changes what runs; vendors re-init from the cookie.
export async function decideConsent({
  state,
  action,
}: {
  state: ConsentState
  action: ConsentDecisionAction
}) {
  const changed = state.advertising !== readEffectiveConsent().advertising
  const saved = await postConsent({ advertising: state.advertising, action })
  // Offline: a script write keeps the page honest until the next post.
  if (!saved) writeConsentRecord({ ...state, gpc: hasGpcSignal() })
  if (!state.advertising) {
    document.cookie.split('; ').forEach((pair) => {
      const name = pair.split('=')[0]
      if (ADVERTISING_COOKIE.test(name)) deleteCookie(name)
    })
  }
  if (changed) window.location.reload()
}

// At load: a record not yet made under the signal takes the signal's decision.
export function honorSignal() {
  if (!hasGpcSignal() || readConsentRecord()?.gpc) return
  void postConsent({ source: 'signal' })
}
